export default __webpack_public_path__ + "static/media/expiredQr.d6f17d3c.jpg";